<template>
 <div class="element-snackbar">
   <transition-group name="element-snackbar" tag="ul" v-if="Object.values( items ).filter( o => o.visible ).length">
     <li v-for="( item, i ) in items" class="element-snackbar-item" :class="item.status" :key="i+'_'+item.message" v-if="item.visible">
       <div class="close" @click="closeSnackbar( i )">×</div>{{ item.message }}
     </li>
   </transition-group>
 </div>
</template>
<script>
export default {
 data(){
   return {
     autoClose: null
   };
 },
 computed: {
   items(){
     return this.$store.getters[ "elementSnackbar/GET_ITEMS" ];
   }
 },
 created(){
   if( !this.$store.state.elementSnackbar ){
     this.$store.registerModule( "elementSnackbar", {
       namespaced: true,
       state: {
         items: {}
       },
       getters: {
         GET_ITEMS: state => {
           return state.items;
         }
       },
       mutations: {
         SET_ITEM: ( state, payload ) => {
           var time = new Date().getTime();
           this.$set( state.items, new Date().getTime(), { ...payload, visible: true });
           setTimeout( () => {
             this.$store.commit( "elementSnackbar/UNSET_ITEM", time );
           }, 3000 );
         },
         UNSET_ITEM: ( state, payload ) => {
           // state.items[ payload ].visible = false;
           this.$delete( state.items, payload );
         },
       },
     });
   };
 },
 methods: {
   closeSnackbar( i ){
     this.$store.commit( "elementSnackbar/UNSET_ITEM", i );
   }
 }
}
</script>
